import { render, staticRenderFns } from "./RelianceDashboard.vue?vue&type=template&id=b430155c&scoped=true&"
import script from "./RelianceDashboard.vue?vue&type=script&lang=js&"
export * from "./RelianceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RelianceDashboard.vue?vue&type=style&index=0&id=b430155c&lang=scss&scoped=true&"
import style1 from "./RelianceDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b430155c",
  null
  
)

export default component.exports